module.exports = __webpack_public_path__ + "img/energy-exchanger.9d570645.png";